import React, { Component } from 'react';
import cross from '../../assets/images/shape-cross.svg';
import Countdown from 'react-countdown';
import EmailLogo from '../../assets/images/email.png';
import MessageLogo from '../../assets/images/message.png';
import { colors } from '@material-ui/core';


export default class OTPModal extends Component {
    constructor() {
        super()
    }

  

    render() {
        if (this.props.mystate.isModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                    <div class="modal-dialog friendly-calls-modal" role="document">
                        <div class="modal-content control-modal">
                            <div className="container">
                                <div className="otp-verification-div">
                                    <div className="otp-verification-EmailLogoDiv">
                                        {
                                            this.props.mystate.verificationType === 'email' ?
                                                <img src={EmailLogo} alt="logo" />
                                                :
                                                <img src={MessageLogo} alt="logo" />
                                        }

                                    </div>
                                    {
                                        this.props.mystate.verificationType === 'email' ?
                                            <div className='otp-verfication-content-div'>

                                                <h4>Check Your Email</h4>
                                                <p>Please enter the Otp we sent to <span>{this.props.mystate.userEmail}</span> to verify your email.</p>
                                            </div>
                                            :
                                            <div className='otp-verfication-content-div'>

                                                <h4>Check Your Mobile</h4>
                                                <p>Please enter the Otp we sent to <span>{this.props.mystate.userMobile}</span> to verify your Mobile Number.</p>
                                            </div>
                                    }

                                    <div class="form-group" style={{ textAlign: 'center' }}>

                                        <input type="text" class="form-control-ausi" id="txtVerificationOtp" name="txtVerificationOtp" value={this.props.mystate.txtVerificationOtp}
                                            onChange={this.props.HandleVerificationInputs}
                                            //   onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                            placeholder="Enter Otp" />

                                    </div>
                                    <div className='reset-password-login-btn'>
                                        <button type="button" class="btn login-button" id="btnGoToLogin" name="btnGoToLogin" onClick={() => this.props.VerifyOtp()}>Verify Otp</button>
                                    </div>
                                    {
                                        this.props.mystate.verificationType === 'email' ?
                                            (this.props.mystate.count === 0 ?
                                                <div className="resend-otp cursor-pointer">

                                                    <p onClick={() => this.props.SendOtp()}>No Email? Click to resend</p>

                                                </div>
                                                :
                                                <div className="resend-otp cursor-pointer">

                                                   
                                                <span>Wait for <Countdown date={Date.now() + 60000} precision={1} intervalDelay={1000}
                                                renderer={props => props.total / 1000} onComplete={()=>this.props.SetCoundown()}
                                            ></Countdown> seconds</span>

                                                    <p style={{ cursor: 'default', color: '#4f5c73' }} >No Email? Click to resend</p>
                                                </div>
                                            )

                                            :
                                            (this.props.mystate.count === 0 ?
                                                <div className="resend-otp cursor-pointer">

                                                    <p onClick={() => this.props.SendOtp()}>No Message? Click to resend</p>

                                                </div>
                                                :
                                                <div className="resend-otp cursor-pointer">

                                                    <span>Wait for <Countdown date={Date.now() + 60000} precision={1} intervalDelay={1000}
                                                        renderer={props => props.total / 1000} onComplete={()=>this.props.SetCoundown()}
                                                    ></Countdown> seconds</span>

                                                    <p style={{ cursor: 'default', color: '#4f5c73' }} >No Message? Click to resend</p>

                                                </div>
                                            )

                                    }



                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}